import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "modelSelect"];

  openModal(event) {
    event.preventDefault();
    this.modalTarget.classList.remove("hidden");
    this.modalTarget.classList.add("show");
  }

  closeModal() {
    this.modalTarget.classList.remove("show");
    this.modalTarget.classList.add("hidden");
  }

  continueWithModel(event) {
    const model = this.modelSelectTarget.value;
    const url = event.target.dataset.url;
    const separator = url.includes('?') ? '&' : '?';
    window.location.href = `${url}${separator}model=${encodeURIComponent(model)}`;
  }
}
